// extracted by mini-css-extract-plugin
export default {"dot":"MarkDot_dot__8Mo0R","animation":"MarkDot_animation__gVcjE","pulsate":"MarkDot_pulsate__d8Uru","grey":"MarkDot_grey__TSQfn","popover":"MarkDot_popover__LefOV"};